import { useState, useEffect } from 'react';

const MESSAGES = [
  { emoji: '☕', text: "Go grab a coffee — we're doing the hard work..." },
  { emoji: '🕵️', text: 'Investigating your site like Sherlock Holmes...' },
  { emoji: '🐛', text: 'Chasing broken links through the dark web of your site...' },
  { emoji: '🧠', text: 'Teaching our AI to read your sitemap... slowly...' },
  { emoji: '🔍', text: 'Crawling page by page like a very dedicated intern...' },
  { emoji: '😅', text: 'Still going... your site is impressively large.' },
  { emoji: '🚀', text: 'Almost there... probably.' },
  { emoji: '🧩', text: 'Connecting the dots between your pages...' },
  { emoji: '🤖', text: 'Beep boop — robot at work, do not disturb.' },
  { emoji: '⏳', text: 'Fun fact: the average SEO audit takes 3 minutes. Ours takes 2:58.' },
  { emoji: '🎯', text: 'Scanning for orphan pages... no page left behind.' },
  { emoji: '🍕', text: 'This is taking longer than ordering pizza. Almost done though.' },
  { emoji: '💡', text: 'Pro tip: while you wait, go fix a typo on your homepage.' },
  { emoji: '🐢', text: 'Slow and steady wins the SEO race.' },
  { emoji: '🎲', text: "Did you know? Google crawls 100B pages per day. We're doing yours." },
];

export default function LoadingMessages({ style }) {
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * MESSAGES.length));
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(i => (i + 1) % MESSAGES.length);
        setVisible(true);
      }, 400);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const { emoji, text } = MESSAGES[idx];

  return (
    <div style={{
      padding: '20px 24px',
      background: 'rgba(124,58,237,0.06)',
      border: '1px solid rgba(124,58,237,0.15)',
      borderRadius: 14,
      ...style,
    }}>
      <style>{`
        @keyframes lm-pulse {
          0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(124,58,237,0.35); }
          50% { transform: scale(1.1); box-shadow: 0 0 0 10px rgba(124,58,237,0); }
        }
        @keyframes lm-bar {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(60%); }
          100% { transform: translateX(260%); }
        }
      `}</style>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
        <div style={{
          width: 52, height: 52,
          background: 'rgba(124,58,237,0.15)',
          border: '1px solid rgba(124,58,237,0.3)',
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 24,
          animation: 'lm-pulse 2s ease-in-out infinite',
        }}>
          {emoji}
        </div>

        <p style={{
          fontSize: 13,
          fontWeight: 600,
          color: '#c4b5fd',
          margin: 0,
          textAlign: 'center',
          opacity: visible ? 1 : 0,
          transition: 'opacity 0.4s ease',
          minHeight: 20,
        }}>
          {text}
        </p>

        <div style={{
          width: '100%',
          height: 4,
          background: 'rgba(255,255,255,0.07)',
          borderRadius: 99,
          overflow: 'hidden',
        }}>
          <div style={{
            height: '100%',
            width: '40%',
            background: 'linear-gradient(90deg, #7c3aed, #3b82f6)',
            borderRadius: 99,
            animation: 'lm-bar 1.8s ease-in-out infinite',
          }} />
        </div>
      </div>
    </div>
  );
}
